import React, { useState } from 'react';
import { supabase } from '../../supabaseClient';
import { useAuth } from '../../context/AuthContext';
import { ensureInstitutionOnPayload } from '../../lib/tenant';
import '../../styles/DptForm.css';

export default function DptForm({ onDptAdded }) {
  const { isAdmin, instituicaoId } = useAuth();
  const [nome, setNome] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nome) return alert('Preencha o nome do departamento');

    const payload = ensureInstitutionOnPayload({ nome }, isAdmin, instituicaoId);
    const { data, error } = await supabase
      .from('departamentos')
      .insert([payload])
      .select()
      .single();

    if (error) console.error('Erro ao criar departamento:', error.message);
    else {
      onDptAdded(data);
      setNome('');
    }
  };

  return (
    <form className="dpt-form" onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Nome do departamento"
        value={nome}
        onChange={(e) => setNome(e.target.value)}
      />
      <button type="submit">Adicionar Departamento</button>
    </form>
  );
}
